<template>
  <div class="container">
    <div class="header">
      <div class="left">
        共 {{ fileList.length }} {{ unit }}（{{ totalSize }}）
      </div>
      <div class="right">
        <span @click="handleCheckAllChange(true)">全选</span>
        <span @click="handleCheckAllChange(false)">取消全选</span>
        <span @click="handleDeleteAll">删除全部</span>
      </div>
    </div>
    <div class="content">
      <div
        v-if="fileList.length <= 20"
        @click="handleAddResource"
        class="item-box item-box-add"
      >
        <div class="add-box">
          <i style="font-size: 45px; color: #999999" class="el-icon-plus"></i>
        </div>
      </div>
      <div class="item-box" v-for="item in fileList" :key="item.uid">
        <el-checkbox
          @change="handleChange(item)"
          class="check-box"
          v-model="item.checked"
        ></el-checkbox>
        <div>
          <div class="imgBox">
            <!-- <img :src="item.url" alt=""> -->
            <el-image
              v-if="resourceType == 1"
              class="imgview"
              fit="cover"
              :src="item.thumbnailUrl"
              :preview-src-list="[item.url]"
            >
            </el-image>
            <video
              @click="handlePlayVideo(item.url)"
              width="100%"
              height="100%"
              v-else
              :poster="item.frameImg ? item.frameImg : videoDefualtCover"
              :src="item.url"
            ></video>
            <img
              v-if="item.url"
              class="icon"
              src="@/assets/images/upload/uploadSucess.png"
              alt=""
            />
            <img
              v-else
              class="icon"
              src="@/assets/images/upload/uploadError.png"
              alt=""
            />
          </div>
          <div class="title">
            {{ item.label }}
          </div>
        </div>
      </div>
    </div>
    <videoPlay
      v-if="resourceType == 3"
      :visible.sync="dialogVisible"
      :videoUrl="videoUrl"
    ></videoPlay>
  </div>
</template>

<script>
import videoDefualtCover from "@/assets/images/upload/videoDefualtCover.png";
import videoPlay from "./videoPlay.vue";
export default {
  name: "uploadResource",
  components: {
    videoPlay,
  },
  props: {
    uploadFileList: {
      type: Array,
      default: () => [],
    },
    resourceType: {
      type: String,
      default: "1",
    },
    registerType: {
      default: "1",
    },
  },
  data() {
    return {
      videoDefualtCover,
      fileList: [],
      dialogVisible: false,
      videoUrl: "",
    };
  },
  computed: {
    totalSize() {
      let size = 0;
      this.fileList.forEach((item) => {
        size += item.size;
      });
      let value = Math.floor((size / 1024 / 1024) * 100) / 100;
      return value + " MB";
    },
    unit() {
      return this.resourceType == 1 ? "张" : "个";
    },
  },
  methods: {
    handleCheckAllChange(flag) {
      if (this.registerType == 1) {
        this.$message.error("已登记作品不支持多选");
        return;
      }
      this.fileList.forEach((item) => {
        item.checked = flag;
      });
    },
    handleDeleteAll() {
      this.fileList = [];
      this.$emit("clearAll");
      // this.$emit('getData',this.fileList);
    },
    handlePlayVideo(url) {
      this.videoUrl = url;
      this.dialogVisible = true;
    },
    getFileList() {
      return this.fileList;
    },
    upDateFileList() {
      this.fileList = this.fileList.filter((item) => !item.checked);
    },
    handleChange(item) {
      if (this.registerType == "1") {
        const checkedList = this.fileList.filter((item) => item.checked);
        if (checkedList.length > 1) {
          this.$message.error("已登记作品不支持多选");
          item.checked = false;
          return;
        }
      }
    },
    handleAddResource() {
      this.$emit("uploadResource");
    },
  },
  watch: {
    uploadFileList: {
      handler() {
        this.fileList = this.uploadFileList.map((item, index) => {
          return {
            ...item,
            label: item.workFileName,
            thumbnailUrl: item.thumbnailUrl,
            url: item.url,
            size: item.workFileSize,
            checked: index == 0,
            uid: Math.random()
              .toString(16)
              .slice(2),
            workFileSize: item.workFileSize,
            frameImg: item.frameImg,
            ratio: item.ratio,
          };
        });
        this.$emit("getData", this.fileList);
      },
      deep: true,
    },
    registerType: {
      handler(val) {
        console.log(`val----`, val);
        if (val == 1) {
          if (!this.fileList.length) return;
          this.fileList.forEach((item, index) => {
            item.checked = index == 0;
          });
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
/* // 转换px到rem的函数 */
@function px2rem($px) {
  @return $px + px;
}

.container {
  height: 100%;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: px2rem(8);
    font-weight: 400;
    font-size: px2rem(14);
    .left {
      color: #999999;
    }
    .right {
      color: #4e89ff;
      span {
        margin-right: px2rem(10);
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
.content {
  display: flex;
  flex-wrap: wrap;
  max-height: px2rem(600);
  overflow-y: auto;
  .item-box-add {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    .add-box {
      width: px2rem(163);
      height: px2rem(188);
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      border: px2rem(1) dashed #409eff;
      border-radius: px2rem(10);
    }
  }
  .item-box {
    width: px2rem(180);
    margin-right: px2rem(10);
    margin-bottom: px2rem(10);
    height: px2rem(250);
    padding: px2rem(5);
    background: #f6f9ff;
    border-radius: px2rem(3);
    border: px2rem(1) solid #f6f9ff;
    &:last-child {
      margin-right: 0;
    }
    .check-box {
      /* margin-bottom: px2rem(9); */
      margin-left: px2rem(10);
    }
    .imgBox {
      width: px2rem(163);
      height: px2rem(188);
      margin: 0 auto;
      position: relative;

      img.icon {
        width: px2rem(32);
        height: px2rem(32);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        pointer-events: none;
      }
      .imgview {
        width: 100%;
        height: 100%;
        border-radius: px2rem(10);
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .title {
      font-weight: 400;
      font-size: px2rem(15);
      color: #333333;
      /* margin-top: px2rem(9); */
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

// 响应式适配
@media screen and (max-width: 768px) {
  .container {
    font-size: 14px !important;
  }
}

@media screen and (max-width: 480px) {
  .container {
    font-size: 12px !important;
  }
  .content .item-box {
    width: px2rem(120);
    height: px2rem(160);
  }
  .imgBox {
    width: px2rem(110);
    height: px2rem(120);
  }
}
</style>
